export default __webpack_public_path__ + "imgs/w-chance-miss-item.png";